import { useShallow } from 'zustand/react/shallow';
import { useEffect } from 'react';
import HeroBanner from '../HeroBanner/HeroBanner';
import Carousel from '../Carousel/Carousel';
import StoriesStrip from '../Stories/StoriesStrip';
import { useCarouselSlides } from '../../hooks/useCarouselSlides';
import { Campaign } from '../../types/commerce';
import CollectionSection from '../Collections/CollectionSection';
import { useCollectionStore } from '../../store/collectionStore';
import { useScrollRestoration } from '../../hooks/useScrollRestoration';
import './HomePage.css';
// The API returns only live slides, so a scheduled one is a running sale worth opening on.
const runningSale = (slides: readonly Campaign[]) => slides.find((s) => s.starts_at || s.ends_at)?.id;

export default function HomePage() {
  const slides = useCarouselSlides();
  const homeSlides = slides.home ?? [];
  const { home, homeLoading, homeError, fetchHome } = useCollectionStore(
    useShallow((s) => ({
      home: s.home,
      homeLoading: s.homeLoading,
      homeError: s.homeError,
      fetchHome: s.fetchHome,
    })),
  );
  useEffect(() => {
    fetchHome();
  }, [fetchHome]);
  useScrollRestoration('home');
  return (
    <div className="home-page">
      <Carousel
        label="Featured"
        slides={homeSlides}
        leading={<HeroBanner />}
        featuredId={runningSale(homeSlides)}
      />
      <section className="home-page__collection page-container" id="product-gallery">
        {homeLoading ? (
          <p role="status">Loading collections…</p>
        ) : homeError ? (
          <div role="alert">
            <p>{homeError}</p>
            <button onClick={fetchHome}>Try again</button>
          </div>
        ) : (
          home.map((c) => <CollectionSection key={c.slug} collection={c} slides={slides[c.slug] ?? []} />)
        )}
      </section>
      <StoriesStrip />
    </div>
  );
}
